import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../../public/images/gambeat_logo_square_red_white_text.svg'
import _imports_1 from '../../public/images/arrow.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  class: "column items-center text-weight-bolder text-uppercase",
  style: {"font-size":"26px"}
}, [
  /*#__PURE__*/_createElementVNode("img", {
    width: "214",
    height: "185",
    src: _imports_0
  })
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "after-logo-hr" }, null, -1)
const _hoisted_3 = { class: "column" }
const _hoisted_4 = { class: "enter-btn-container" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "q-mr-sm" }, "Authorize", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_7 = { class: "enter-btn-container q-mt-md" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "q-mr-sm" }, "Sign Up", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_page = _resolveComponent("q-page")!
  const _component_q_page_container = _resolveComponent("q-page-container")!

  return (_openBlock(), _createBlock(_component_q_page_container, { class: "page-bg" }, {
    default: _withCtx(() => [
      _createVNode(_component_q_page, {
        class: "q-layout-container column justify-center items-center page-bg-img",
        style: {"min-height":"auto !important"}
      }, {
        default: _withCtx(() => [
          _hoisted_1,
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_q_btn, {
                class: "authorize-btn",
                "no-caps": "",
                onClick: _ctx.enterRedirect
              }, {
                default: _withCtx(() => [
                  _hoisted_5,
                  _hoisted_6
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_q_btn, {
                class: "authorize-btn",
                "no-caps": "",
                onClick: _ctx.enterSignupRedirect
              }, {
                default: _withCtx(() => [
                  _hoisted_8,
                  _hoisted_9
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}